<template>
  <formWrapper :validator="$v.form">
    <form @submit.prevent="handleAddContact" class="form-box">
      <v-container>
        <v-row>
          <v-col class="py-0" cols="12" lg="3">
            <form-group name="contact_type" :attribute="`fields.contact_type`">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :items="contactTypes"
                  item-value="id"
                  item-text="name"
                  :loading="loadingContactTypes"
                  v-bind="attrs"
                  v-on="listeners"
                  outlined
                  v-model.trim="form.contact_type"
                  type="text"
                >
                </v-select>
              </template>
            </form-group>
          </v-col>

          <v-col class="py-0" cols="12" lg="5" v-if="form.contact_type !== ''">
            <v-row>
              <v-col cols="12" lg="5" v-if="form.contact_type === 1">
                <form-group
                  name="country_code"
                  :attribute="`fields.country_code`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :loading="loadingCountries"
                      :items="countries"
                      item-value="code"
                      item-text="code"
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model.trim="form.country_code"
                      type="text"
                    >
                    </v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" :lg="form.contact_type === 1 ? 7 : 12">
                <form-group
                  :name="contactName"
                  :attribute="`fields.${contactName}`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model.trim="form[contactName]"
                      :type="fieldType"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" lg="4" class="pa-0">
            <v-btn
              height="55"
              class="success text-capitalize"
              large
              type="submit"
              :disabled="$v.form.$invalid"
              :loading="loading"
              ><span>{{ $t("button.add") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </formWrapper>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  requiredIf,
  email,
  url,
} from "vuelidate/lib/validators";
import { IndexData, StoreData } from "@/helpers/apiMethods";
export default {
  name: "FormAction",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contactName: "",
      fieldType: "text",
      contactTypes: [],
      countries: [],
      loading: false,
      loadingContactTypes: true,
      loadingCountries: true,
      form: {
        contact_type: "",
        value: "",
        country_code: "",
        number: "",
        whatsapp: "",
        email: "",
        url: "",
      },
    };
  },
  mounted() {
    this.getContactsType();
  },
  methods: {
    resetData() {
      for (const key in this.form) {
        this.form[key] = "";
      }
      this.contactName = "";
      this.fieldType = "text";
      this.$v.$reset();
    },
    onSave(formData) {
      this.loading = true;
      StoreData({
        reqName: `admin-panel/teachers/${this.$route.params.slug}/contacts`,
        data: formData,
      })
        .then((res) => {
          console.log(res);
          const { contact } = res.data;
          this.items.push(contact);
          this.resetData();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAddContact() {
      const formData = new FormData();
      formData.append("contact_type", this.form.contact_type);
      if (this.form.contact_type === 1) {
        formData.append("value[number]", this.form.number);
        formData.append("value[country_code]", this.form.country_code);
      } else {
        formData.append("value", this.form[this.contactName]);
      }
      this.onSave(formData);
    },
    handleContactValue() {
      switch (this.form.contact_type) {
        case 1:
          this.contactName = "number";
          this.fieldType = "number";

          break;
        case 2:
          this.contactName = "email";
          this.fieldType = "email";
          break;
        case 3:
          this.contactName = "website";
          break;
        case 4:
          this.contactName = "whatsapp";
          this.fieldType = "number";
          break;

        case 5:
          this.contactName = "facebook";
          break;
        case 6:
          this.contactName = "twitter";
          break;
        case 7:
          this.contactName = "instagram";
          break;
      }
    },
    async getContactsType() {
      const res = await IndexData({ reqName: "admin-panel/contact-types" });
      const { data } = res.data;
      this.contactTypes = data;
      this.loadingContactTypes = false;
    },
    async getCountries() {
      const res = await IndexData({ reqName: "admin-panel/countries" });
      const { data } = res.data;
      this.countries = data;
      this.loadingCountries = false;
    },
  },
  validations() {
    return {
      form: {
        contact_type: {
          required,
        },
        country_code: {
          required: requiredIf(function () {
            if (this.form.contact_type === 1) {
              return true;
            } else {
              return false;
            }
          }),
        },
        number: {
          required: requiredIf(function () {
            if (this.form.contact_type === 1) {
              return true;
            } else {
              return false;
            }
          }),
          minLength: minLength(9),
          maxLength: maxLength(15),
        },
        email: {
          required: requiredIf(function () {
            if (this.form.contact_type === 2) {
              return true;
            } else {
              return false;
            }
          }),
          email,
        },
        website: {
          required: requiredIf(function () {
            if (this.form.contact_type === 3) {
              return true;
            } else {
              return false;
            }
          }),
          url,
        },
        whatsapp: {
          required: requiredIf(function () {
            if (this.form.contact_type === 4) {
              return true;
            } else {
              return false;
            }
          }),
          minLength: minLength(9),
          maxLength: maxLength(15),
        },
        facebook: {
          required: requiredIf(function () {
            if (this.form.contact_type === 5) {
              return true;
            } else {
              return false;
            }
          }),
          url,
        },
        twitter: {
          required: requiredIf(function () {
            if (this.form.contact_type === 6) {
              return true;
            } else {
              return false;
            }
          }),
          url,
        },
        instagram: {
          required: requiredIf(function () {
            if (this.form.contact_type === 7) {
              return true;
            } else {
              return false;
            }
          }),
          url,
        },
      },
    };
  },
  watch: {
    "form.contact_type": {
      handler(value) {
        this.handleContactValue();
        if (value === 1) {
          this.getCountries();
        }
      },
      immediate: true,
    },
  },
};
</script>

